import { gql } from '@apollo/client';

export const MODERATOR_QUEUE = gql`
  query moderatorQueue(
    $tab: ModeratorQueueTab!
    $categoryFilter: [ReportCategory!]
    $reasonFilter: [ReportReason!]
    $assigneeFilter: ID
    $limit: Int
    $cursor: String
  ) {
    moderatorQueue(
      tab: $tab
      categoryFilter: $categoryFilter
      reasonFilter: $reasonFilter
      assigneeFilter: $assigneeFilter
      limit: $limit
      cursor: $cursor
    ) {
      entries {
        reportId
        postId
        reason
        category
        details
        reporterId
        reporterUsername
        assignedModeratorId
        assignedModeratorUsername
        assignedAt
        createdAt
        status
        post {
          id
          username
          author {
            avatarUrl
          }
          textBlocks {
            id
            type
            data {
              paragraph
              header
              level
              code
              caption
              # List blocks
              style
              items {
                id
                text
              }
              # Image blocks
              file {
                url
                originalName
                type
                size
              }
              withBorder
              withBackground
              stretched
            }
          }
          createdAt
        }
      }
      cursor
    }
  }
`;
